/* 路由映射 */
export default {
    //"layoutHeaderAside": layoutHeaderAside,
  "login": () => import('views/login/index'),
  "browserVersionReminder": () => import('views/error/browserVersionReminder.vue'),//浏览器版本提醒
  "notFind": ()=> import('views/error/404.vue'),//404页
  "errorServer" : () => import('views/error/errorServe.vue'),//服务器500
  "noAuthUser": () => import('views/error/noAuthUser.vue'),//该用户未授权

  "home": () => import('views/home/index'),

  "matterList": (resolve) => import('views/base/matter/list.vue'),//物料主数据
  "matterAdd": (resolve) => import('views/base/matter/add.vue'),//物料编辑
  "mastMaterialEdit":(resolve)=>import('views/base/matter/MastMaterialEdit.vue'),//主数据物料编辑
  "matterDetail":(resolve)=>import('views/base/matter/detail.vue'),//物料详情
   
  "bomNew":()=>import('views/base/bom/bomNew.vue'),//创建物料清单
  "bomScan":()=>import('views/base/bom/bomScan.vue'),//查看物料清单

  // "bomScan":()=>import('views/base/mattertypeconfig/matTypeConfigPage.vue'),//物料类型配置



  "maCaManagePage":()=>import('views/base/category/MtrlCategoryManagePage.vue'),//物料类别管理
  "unitManagePage":()=>import('views/base/unitmng/UnitManagePage.vue'),//计量单位管理
  "mattertypeconfig":()=>import('views/base/materialtype/MaterialTypePage.vue'),//物料类型配置 
 
  //销售组织
  "saleOrgan":()=>import('views/base/organmng/SaleOrganMngPage.vue'),//组织管理-销售组织
  

  "supplierList":()=>import('views/base/supplier/list.vue'),//供应商
  "supplierAdd":()=>import('views/base/supplier/add.vue'),//新增
  "supplierDetail":()=>import('views/base/supplier/detail.vue'),//详情

  "customerList":()=>import('views/base/customer/list.vue'),//客户
  "customerAdd":()=>import('views/base/customer/add.vue'),//客户
  "customerDetail":()=>import('views/base/customer/detail.vue'),//客户

  "factoryList":()=>import('views/base/factory/list.vue'),//工厂
  "factoryAdd":()=>import('views/base/factory/add.vue'),//工厂
  "factoryDetail":()=>import('views/base/factory/detail.vue'),//工厂

  "fstockList":()=>import('views/base/fstock/list.vue'),//库位
  "fstockAdd":()=>import('views/base/fstock/add.vue'),//库位
  "fstockDetail":()=>import('views/base/fstock/detail.vue'),//库位

  "purchaseinList":()=>import('views/business/purchasein/list.vue'),//采购入库
  "purchaseinAdd":()=>import('views/business/purchasein/add.vue'),//采购入库
  "purchaseinDetail":()=>import('views/business/purchasein/detail.vue'),//采购入库

  "purchaseoutList":()=>import('views/business/purchaseout/list.vue'),//采购入库退货
  "purchaseoutAdd":()=>import('views/business/purchaseout/add.vue'),//采购入库退货
  "purchaseoutDetail":()=>import('views/business/purchaseout/detail.vue'),//采购入库退货

  "saleList":()=>import('views/business/sale/list.vue'),//销售出库
  "saleAdd":()=>import('views/business/sale/add.vue'),//销售出库
  "saleDetail":()=>import('views/business/sale/detail.vue'),//销售出库

  "salebackList":()=>import('views/business/saleback/list.vue'),//销售出库退货
  "salebackAdd":()=>import('views/business/saleback/add.vue'),//销售出库退货
  "salebackDetail":()=>import('views/business/saleback/detail.vue'),//销售出库退货


  "saleOrder":()=>import('views/business/sale/order.vue'),//创建销售订单
  // "saleOrderRevise":()=>import('views/business/sale/orderRevise.vue'),//修改销售订单
  "saleOrderSend":()=>import('views/business/sale/orderSend.vue'),//销售订单发货
  "saleOrderCancel":()=>import('views/business/sale/orderCancel.vue'),//销售订单退货
  "saleOrderList":()=>import('views/business/sale/orderList.vue'),//销售订单查询
  "saleOrderHelp":()=>import('views/business/sale/orderHelp.vue'),//维护销售价格  
  //"batchHelp":()=>import('views/business/sale/batchHelp.vue'),//维护芳疗批次页
  "batchHelp":()=>import('views/business/sale/SaleBatchFeatureBill.vue'),//维护芳疗批次页
  //"batchCharact":()=>import('views/business/sale/batchCharact.vue'),//查询芳疗批次页  
  "batchCharact":()=>import('views/business/sale/components/salebatchfeature/SaleBatchFeatureMtrlSpage.vue'),//查询芳疗批次页

  "purchaseOrderNew":()=>import('views/business/purchaseorder/purchaseordernew.vue'),//采购订单-新增
  "purchaseOrderSearch":()=>import('views/business/purchaseorder/PurchaseOrderSch.vue'),//采购订单-查询
  "purchaseOrderEdit":()=>import('views/business/purchaseorder/PurchaseOrderEdit.vue'),//采购订单-编辑
  "purchaseOrderReap":()=>import('views/business/purchaseorder/PurchaseOrderReap.vue'),//采购订单-收货
  "purchaseOrderReapCancel":()=>import('views/business/purchaseorder/PurchaseOrderReapCancel.vue'),//采购订单-退货

  
  "productionOrderNew":()=>import('views/business/production/orderNew.vue'),//创建生产订单
  "productionOrderNewRevise":()=>import('views/business/production/orderNewRevise.vue'),//修改生产订单
  "productionOrderCheckout":()=>import('views/business/production/ProdOrderCheckoutPanel.vue'),//生产订单出库
  "productionOrderCheckinput":()=>import('views/business/production/ProdOrderCheckinputPanel.vue'),//生产订单入库
  "productOrderSearch":()=>import('views/business/production/ProductOrderSchPanel.vue'),//生产订单查询
  "ProdOrderBackflush":()=>import('views/business/production/ProdOrderBackflush.vue'),//生产订单入库反冲
  "ProdOrderIssueBackflush":()=>import('views/business/production/ProdOrderIssueBackflushPanel.vue'),//生产订单出库反冲 




  "stockadjustIn":()=>import('views/business/stockadjust/in.vue'),//入库
  "stockadjustOut":()=>import('views/business/stockadjust/out.vue'),//出库
  "stockadjustList":()=>import('views/business/stockadjust/list.vue'),//查询列表
  "stockadjustDetail":()=>import('views/business/stockadjust/detail.vue'),//调整单详情

  "reportPurchasein":()=>import('views/report/purchasein/index.vue'),//采购报表
  "reportSale":()=>import('views/report/sale/index.vue'),//销售报表
  "reportStock":()=>import('views/report/stock/index.vue'),//库存查询
  "reportPeriod":()=>import('views/report/stock/period.vue'),//期间库存查询
  "reportMultiple":()=>import('views/report/multiple/jxc.vue'),//综合查询
  "reportMaterialreport":()=>import('views/report/multiple/material.vue'),//物料移动单据表


  "companyList":()=>import('views/system/system/company/list.vue'),//公司列表
  "resourceList":()=>import('views/system/auth/resource/list.vue'),//资源列表
  "roleList":()=>import('views/system/auth/role/list.vue'),//角色列表
  "roleAuth":()=>import('views/system/auth/role/auth.vue'),//角色权限
  "userList":()=>import('views/system/auth/user/list.vue'),//用户列表
  "monitorLog":()=>import('views/system/monitor/log.vue'),//系统日志
  "SelectedOrderList":()=>import('views/business/sale/SaleOrderListSelect.vue'),//选择销售单列表


  //平台管理 
  "platform_resourceperm_resource_query":()=>import('views/platform/resource/PlatformResQPage.vue'),//查询平台资源

  //平台管理  
  "platform_tanant_query":()=>import('views/platform/tenant/TenManageQueryPage.vue'),//租户管理
  "platform_tanant_freeze":()=>import('views/platform/tenant/TenantMngPermiPage.vue'),//租户授权管理

  //电商管理
  "baseEbmngMatchgoodsmng":()=>import('views/onlineretail/ebmanage/MatchGoodsMngQpage.vue'),//商品匹配管理
  "baseEbmngEbOrderMng":()=>import('views/onlineretail/ebmanage/OnlineOrderMngQpage.vue'),//订单匹配管理

}
